import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'permissionName'
})
export class PermissionNamePipe implements PipeTransform {

  private replaceWith = [
    {replace: 'Eo ', with: 'EO '},
    {replace: 'Mx ', with: 'MX '},
    {replace: 'Aes ', with: 'AES '},
    {replace: 'Torch', with: 'TORCH'},
    {replace: 'Crt ', with: 'CRT '},
    {replace: 'Tech Ops ', with: 'TechOps '},
    {replace: 'Kpi ', with: 'KPI '},
    {replace: 'Admin', with: 'Administrator'},
  ];

  transform(value: string): string {
    return this.splitCamelCaseToString(value);
  }

  splitCamelCaseToString(s) {
    let stringCase = s.split(/(?=[A-Z])/).map((p) => p.charAt(0).toUpperCase() + p.slice(1))
      .join(' ');

    this.replaceWith.forEach(r => {
      stringCase = stringCase.replace(r.replace, r.with);
    });

    return stringCase;
  }

}
